module.exports = __webpack_public_path__ + "assets/sounds/another-message.mp3";